import type { JSX } from 'react';
import { Badge, Group, Text, Tooltip } from '@mantine/core';
import { codigoDoCurso } from '../lib/curso.js';

/**
 * Quem é a pessoa, numa linha — ou o aviso de que ninguém sabe.
 *
 * Um componente só para as duas telas (Conversas e Transbordos) porque a
 * decisão é a mesma nas duas, e porque a ausência é tão informativa quanto a
 * presença: contato fora do SAGA com conversa aberta é PROVÁVEL INTERESSADO,
 * informação comercial que a secretaria pediu para ver.
 *
 * Cor nunca sozinha: os dois selos têm texto.
 */
export function OrigemDoContato({
  tipo,
  curso,
  anac,
  noSaga,
  tamanho = 'xs',
}: {
  tipo: string | null;
  curso?: string | null;
  anac?: string | null;
  noSaga: boolean;
  tamanho?: 'xs' | 'sm';
}): JSX.Element | null {
  if (!noSaga) {
    return (
      <Tooltip label="não está no sistema acadêmico — provável interessado">
        <Badge size={tamanho} variant="light" color="violet">
          interessado
        </Badge>
      </Tooltip>
    );
  }

  const codigo = codigoDoCurso(curso ?? null);
  return (
    <Group gap={4} wrap="nowrap">
      {tipo && (
        <Badge size={tamanho} variant="light" color="teal">
          {tipo}
        </Badge>
      )}
      {codigo && (
        <Tooltip label={curso ?? codigo} disabled={!curso || curso === codigo}>
          <Text size="xs" c="dimmed">
            {codigo}
          </Text>
        </Tooltip>
      )}
      {anac && (
        <Text size="xs" c="dimmed" ff="monospace">
          CANAC {anac}
        </Text>
      )}
    </Group>
  );
}
